// extracted by mini-css-extract-plugin
module.exports = {"MyAccount":"MyAccount_MyAccount__1zHUA"};